import styled from 'styled-components';
export const AuthWrapper = styled.div `
  padding: 0rem 2.2rem 4.5rem;
`;
//# sourceMappingURL=styles.js.map